var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33073 1.66667C1.33073 2.03486 1.62921 2.33333 1.9974 2.33333C2.36559 2.33333 2.66406 2.03486 2.66406 1.66667C2.66406 1.29848 2.36559 1 1.9974 1C1.62921 1 1.33073 1.29848 1.33073 1.66667Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33073 7.00065C1.33073 7.36884 1.62921 7.66732 1.9974 7.66732C2.36559 7.66732 2.66406 7.36884 2.66406 7.00065C2.66406 6.63246 2.36559 6.33398 1.9974 6.33398C1.62921 6.33398 1.33073 6.63246 1.33073 7.00065Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33073 12.3327C1.33073 12.7009 1.62921 12.9993 1.9974 12.9993C2.36559 12.9993 2.66406 12.7009 2.66406 12.3327C2.66406 11.9645 2.36559 11.666 1.9974 11.666C1.62921 11.666 1.33073 11.9645 1.33073 12.3327Z",
    stroke: "#151515",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/seeMore.db5737e683c7ece594ccd31b448b6f42.svg";
export { ForwardRef as ReactComponent };